import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Backend } from "../services/Backend";
import { Badge, Button, Chip, FormControl, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField,  } from "@mui/material";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import moment from "moment";
import DeleteIcon from '@mui/icons-material/Delete';
import { SuccessToast } from "../utils/utils";
import DeleteButton from "../components/DeleteButton";

export default function AdminDocumentPage() {
    const navigate = useNavigate();
    const [documents, setDocuments] = useState([]);

    const [interest, setInterest] = useState("");
    const [language, setLanguage] = useState("");
    const [publisher, setPublisher] = useState("");
    const [sortBy, setSortBy] = useState("none");
    const [orderBy, setOrderBy] = useState("asc");

    const [disciplinaryContext, setDisciplinaryContext] = useState("");
    const [format, setFormat] = useState("");

    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    useEffect(() => {
        const body = {
            interest,
            language,
            publisher,
            disciplinaryContext,
            format,
            sortBy: `${sortBy}_${orderBy}`,
            page
        };

        Backend.post("document/search/with-url", body)
            .then(res => {
                setDocuments(res.data)
                setTotalCount(res.totalCount);
            });
    }, [page]);

    const handleSearch = () => {
        const body = {
            interest,
            language,
            publisher,
            disciplinaryContext,
            format,
            sortBy: `${sortBy}_${orderBy}`,
        };

        Backend.post("document/search/with-url", body)
            .then(res => {
                setDocuments(res.data)
                setTotalCount(res.totalCount);
            });
    }

    const goToPreviewPage = (row) => {
        if (row.publisher) {
            navigate(`/best-practice/${row.id}`);
        } else {
            navigate(`/url/${row.id}`);
        }
    }

    const resetFilters = () => {
        setInterest("");
        setLanguage("");
        setPublisher("");
        setDisciplinaryContext("");
        setFormat("");
        setSortBy("none");
        setOrderBy("asc");
        setPage(0);

        Backend.post("document/search/with-url", {
            interest: "",
            language: "",
            publisher: "",
            disciplinaryContext: "",
            format: "",
            sortBy: `${sortBy}_${orderBy}`,
            page: 0
        })
            .then(res => {
                setDocuments(res.data)
                setTotalCount(res.totalCount)
            });
    }

    const deleteDocument = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
  
        Backend.delete(`document/${id}`)
            .then(res => {
                SuccessToast("Best practice deleted");
                setTimeout(() => window.location.href = '/dashboard/best-practices', 1000);
            });
    }

    const deleteUrl = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
  
        Backend.delete(`url/${id}`)
            .then(res => {
                SuccessToast("Url deleted");
                setTimeout(() => window.location.href = '/dashboard/best-practices', 1000);
            });
    }

    const handleDelete = (e, row) => {
        if (row.publisher) {
            deleteDocument(e, row.id);
        } else {
            deleteUrl(e, row.id);
        }
    }

    return <div>
        <div className="flex gap-3  items-center">
            <FormControl sx={{ width: "200px"}} margin="normal" size="small">
                <InputLabel>Interest</InputLabel>
                <Select
                    size="small"
                    label="Interest"
                    margin="normal"
                    value={interest}
                    onChange={(e) => setInterest(e.target.value)}
                >
                    <MenuItem value="Transport safety">Transport safety</MenuItem>
                    <MenuItem value="Industrial safety">Industrial safety</MenuItem>
                    <MenuItem value="Chemical warehousing">Chemical warehousing</MenuItem>
                    <MenuItem value="Tank storage">Tank storage</MenuItem>
                </Select>
            </FormControl>
            <FormControl sx={{ width: "200px"}} margin="normal" size="small">
                <InputLabel >Language</InputLabel>
                    <Select
                        size="small"
                        label="Language"
                        margin="normal"
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                    >
                        <MenuItem value="English">English</MenuItem>
                        <MenuItem value="Dutch">Dutch</MenuItem>
                        <MenuItem value="German">German</MenuItem>
                        <MenuItem value="Spanish">Spanish</MenuItem>
                        <MenuItem value="French">French</MenuItem>
                        <MenuItem value="Chinese">Chinese</MenuItem>
                    </Select>
            </FormControl>
            <TextField margin="normal" label="Publisher" size="small" value={publisher} onChange={(e) => setPublisher(e.target.value)} /> 
            <FormControl  sx={{ width: "200px"}} margin="normal">
                <InputLabel>Sort by</InputLabel>
                <Select
                    label="Sort by"
                    size="small"
                    margin="normal"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                >
                    <MenuItem value="none">None</MenuItem>
                    <MenuItem value="title">Title</MenuItem>
                    <MenuItem value="interest">Interest</MenuItem>
                    <MenuItem value="language">Language</MenuItem>
                    <MenuItem value="publisher">Publisher</MenuItem>
                    <MenuItem value="uploadDate">Upload date</MenuItem>
                    <MenuItem value="views">Views</MenuItem>
                    <MenuItem value="rating">Rating</MenuItem>
                </Select>
            </FormControl>
            <FormControl  sx={{ width: "200px"}} margin="normal">
                <InputLabel>Order</InputLabel>
                <Select
                    label="Order"
                    size="small"
                    margin="normal"
                    value={orderBy}
                    onChange={(e) => setOrderBy(e.target.value)}
                    disabled={sortBy === "none"}
                >
                    <MenuItem value="desc">A &gt; Z</MenuItem>
                    <MenuItem value="asc">Z &gt; A</MenuItem>
                </Select>
            </FormControl>
        </div>
        <div className="flex gap-3  items-center">
            <FormControl sx={{ width: "200px"}} margin="normal" size="small">
                <InputLabel>Disciplinary context</InputLabel>
                <Select
                    size="small"
                    label="Disciplinary context"
                    margin="normal"
                    value={disciplinaryContext}
                    onChange={(e) => setDisciplinaryContext(e.target.value)}
                >
                    <MenuItem value="Normative">Normative</MenuItem>
                    <MenuItem value="Scientific">Scientific</MenuItem>
                    <MenuItem value="Tools and techniques">Tools and techniques</MenuItem>
                    <MenuItem value="Legislative">Legislative</MenuItem>
                </Select>
            </FormControl>
            <FormControl sx={{ width: "200px"}} margin="normal" size="small">
                <InputLabel>Format</InputLabel>
                    <Select
                        size="small"
                        label="Format"
                        margin="normal"
                        value={format}
                        onChange={(e) => setFormat(e.target.value)}
                    >
                        <MenuItem value="pdf">PDF</MenuItem>
                        <MenuItem value="docx">DOCX</MenuItem>
                        <MenuItem value="doc">DOC</MenuItem>
                    </Select>
            </FormControl>
        </div>
        <Button variant="contained" sx={{ mr:1 }} onClick={handleSearch}>Search</Button>
        <Button variant="contained" color="error" onClick={resetFilters}>Reset</Button>
        <br/>
        <br/>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <TableRow className="bg-slate-950">
                        <TableCell >Id</TableCell>
                        <TableCell >Title</TableCell>
                        <TableCell >Interest</TableCell>
                        <TableCell width="15%">Upload date</TableCell>
                        <TableCell >Views</TableCell>
                        <TableCell >Rating</TableCell>
                        <TableCell >Type</TableCell>
                        <TableCell ></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {documents.map((row) => (
                    <TableRow key={row.id} onClick={() => goToPreviewPage(row)}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell> <p className="">{row.title}</p></TableCell>
                        <TableCell >{row.interest}</TableCell>
                        <TableCell width="13%">{moment(row.uploadDate).local().format("YYYY-MM-DD")}</TableCell>
                        <TableCell >{row.views}</TableCell>
                        <TableCell >{row.rating ? Math.floor(row.rating) : 0}  / 5</TableCell>
                        <TableCell className="!text-center"><Chip label={row.publisher ? "Best practice" : "Url"} color="primary" /></TableCell>
                        <TableCell><DeleteButton onClick={(e) => handleDelete(e, row)}/></TableCell>
                        {/* <TableCell><DeleteIcon className="cursor-pointer" onClick={(e) => handleDelete(e, row)}/></TableCell> */}
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={totalCount}
            rowsPerPage={10}
            page={page}
            onPageChange={handleChangePage}
            //   rowsPerPage={rowsPerPage}
            //   page={page}
            //   onPageChange={handleChangePage}
            //   onRowsPerPageChange={handleChangeRowsPerPage}
            />
    </div>
}